export default __webpack_public_path__ + "static/media/logo24.f3636681.png";